import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  useRef,
  useMemo,
} from "react";
import ModalConfirm from ".";

const ModalConfirmContext = createContext();

export const ModalConfirmProvider = ({ translateFn, children }) => {
  const [modalProps, setModalProps] = useState(null);
  const resolverRef = useRef();
  const T = useMemo(() => {
    if (typeof translateFn === "function") {
      return translateFn;
    }
    return (key) => key;
  }, [translateFn]);

  const confirm = (props) => {
    return new Promise((resolve) => {
      setModalProps({ ...props, open: true });
      resolverRef.current = resolve;
    });
  };

  const handleClose = useCallback((result) => {
    setModalProps(null);
    if (resolverRef.current) {
      resolverRef.current(result);
      resolverRef.current = null;
    }
  }, []);

  return (
    <ModalConfirmContext.Provider
      value={{ modalProps, confirm, handleClose, T }}
    >
      {children}
      <ModalConfirm />
    </ModalConfirmContext.Provider>
  );
};

export const useModalConfirmContext = () => useContext(ModalConfirmContext);
